export class OrdersValidationPatterns {
	static Address = /^[\d\p{L}\s\+`\$~()_\-={}[\]:;"'.,?\/\\|]+$/u;
	static City = /^[\d\p{L}\s\/.,-_'"]+$/u;
	static ZipCode = /^\d{2}-\d{3}$/;
	static Phone = /^\+?[1-9][\d\s-]*$/;
	static Name = /^[\p{L}\s\-`"']+$/u;
	static Email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
}